module.exports = __webpack_public_path__ + "assets/img/menu_button_dots.svg";